import getPostTypeStaticPaths from '@/functions/wp/posts/getPostTypeStaticPaths';
import getPostTypeStaticProps from '@/functions/wp/posts/getPostTypeStaticProps';
import BlockHeading from '@/components/BlockHeading';
import Container from '@/components/Container';
import Layout from '@/components/Layout';
import BlockPostTitle from '@/components/BlockPostTitle';
import BlockArticleCard from '@/components/BlockArticleCard';
import AuthorSocialShare from '@/components/AuthorSocialShare';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import queryByline from '@/lib/wp/posts/queryByline';
import styles from './Byline.module.scss';

const postType = 'post';

/**
 * Render the Post component
 *
 * @param  {object}  props       component attributes as props
 * @param  {object}  props.post  post data from WP
 * @param  {Array}   props.posts array of posts
 * @return {Element}             Post component
 */
// eslint-disable-next-line react/prop-types
export default function Post() {
  const bylineInfo = {
    author: '',
    title: '',
    affiliation: '',
    twitter: '',
    facebook: '',
    linkedIn: '',
  };
  const { query } = useRouter();
  // eslint-disable-next-line react/prop-types
  const bylineAuthor = query.author;
  const { loading, error, data } = useQuery(queryByline, { variables: { first: 10, byline: bylineAuthor } });
  const bylineList = data?.posts?.edges;

  
    bylineList?.map((post) => {
      if (query.author === post?.node?.bylineInformation?.byline) {
        bylineInfo.author = post?.node?.bylineInformation?.byline;
        bylineInfo.title = post?.node?.bylineInformation?.bylineTitle;
        bylineInfo.affiliation = post?.node?.bylineInformation?.bylineAffiliation;
        bylineInfo.twitter = post?.node?.bylineInformation?.firstTwitterSocialLink;
        bylineInfo.facebook = post?.node?.bylineInformation?.firstFacebookSocialLink;
        bylineInfo.linkedIn = post?.node?.bylineInformation?.firstLinkedinSocialLink;
      } else if (query.author === post?.node?.bylineInformation?.byline2) {
        bylineInfo.author = post?.node?.bylineInformation?.byline2;
        bylineInfo.title = post?.node?.bylineInformation?.byline2Title;
        bylineInfo.affiliation = post?.node?.bylineInformation?.byline2Affiliation;
        bylineInfo.twitter = post?.node?.bylineInformation?.secondTwitterSocialLink;
        bylineInfo.facebook = post?.node?.bylineInformation?.secondFacebookSocialLink;
        bylineInfo.linkedIn = post?.node?.bylineInformation?.secondLinkedinSocialLink;
      } else {
        return {};
      }
    });
  


  return (
    <Layout>
      <Container condensed>
        <div className={styles.byline_header}>
          <p className={styles.byline_posts_by}>Posts by:</p>
          <BlockHeading level={1} content={bylineAuthor} />
          <p className={styles.byline_title}>{bylineInfo?.title}
            {bylineInfo?.affiliation && `, ${bylineInfo?.affiliation}`}</p>
        </div>
      </Container>
      <Container>
        <div className={styles.byline_articles}>
          <div className={styles.byline_articles_col}>
            <BlockPostTitle title="Top Results" />
            {bylineList?.map((post) => (
              <BlockArticleCard
                key={post?.node?.databaseId ?? post?.databaseId}
                postID={post?.node?.databaseId ?? post?.databaseId}
                postType={postType}
                cardType="list"
                columnSpan={6}
              />
            ))}
          </div>
          {(bylineInfo?.twitter || bylineInfo?.facebook || bylineInfo?.linkedIn) && (
            <div className={styles.byline_social_col}>
              <BlockPostTitle title="Follow" />

              <AuthorSocialShare
                twitter={bylineInfo?.twitter}
                facebook={bylineInfo?.facebook}
                linkedIn={bylineInfo?.linkedIn}
              />
            </div>
          )}
        </div>
      </Container>
    </Layout>
  );
}

/**
 * Get post static paths.
 *
 * @return {object} Array of paths and fallbacks
 */
export async function getStaticPaths() {
  return getPostTypeStaticPaths(postType);
}

/**
 * Get post static props
 *
 * @param  {object} context        context for current post
 * @param  {object} context.params route parameters for current post
 * @return {object}                post props
 */
export async function getStaticProps({ params }) {
  return getPostTypeStaticProps(params, postType);
}
